/*
 * Hermes Consoleの色定義
 */
type Color = {
    main: string;
    [key: string]: string;
};

export const colors: { [key: string]: Color } = {
    green: {
        main: "#509D96", // primary
        a50: "rgba(80, 157, 150, 0.5)", // switch_on
        f90: "#EDF5F4", // selected_bg, hover
        b20: "#4B8A85", // hover
        maplink: "rgb(146, 199, 68)", // map link,
        select: "rgba(80, 157, 150, 0.1)",
    },
    blue: {
        main: "#4F92DF", // information
        a50: "rgba(79, 146, 223, 0.5)", // stroke
        f90: "#EDF4FC", // information_bgrgba(80, 157, 150, 0.08)
        b20: "#4A81BF", // hover
    },
    red: {
        main: "#DE6162", // error
        a50: "rgba(222, 97, 98, 0.5)", // stroke
        f90: "#FCEFEF", // error_bg
        b20: "#BD5A5B", // hover
    },
    black: {
        main: "#383E3F", // surface, text
        a90: "rgba(56, 62, 63, 0.9)", // overlay_bg
    },
    gray: {
        main: "#9C9F9F", // subtext
        a50: "rgba(156, 159, 159, 0.5)", // switch_off_bg, text_disabled, disabled
        a20: "rgba(156, 159, 159, 0.2)", // divider, disabled
        a10: "rgba(156, 159, 159, 0.1)", // hover
        f90: "#F5F5F5", // background
        f50: "#CECFCF", // disabled
        b20: "#888B8C", // hover
        b90: "#424849", // snackbar
    },
    white: {
        main: "#FFFFFF", // surface, text
        a90: "rgba(255, 255, 255, 0.9)", // overlay_bg
    },
    transparent: {
        main: "rgba(255, 255, 255, 0)",
    },
};

// 色定義をCSS変数として返す
export const colorsCSS = (): string => {
    let css: string;
    css = ":root {\n";
    for (const k in colors) {
        const key = k as keyof typeof colors;
        for (const type in colors[key] as Color) {
            const code = colors[key][type];
            if (type == "main") {
                css += `    --color-${key}: ${code};\n`;
                continue;
            }
            css += `    --color-${key}-${type}: ${code};\n`;
        }
    }
    css += "}";

    return css;
};
